/* ===========================================================================
   WWC — AR op de productpagina

   EIGEN BESTAND, en dat is een bewuste keuze.

   Deze module zat eerst in wwc-cro.js. Op de klok- en serveerplank-templates
   draaide hij daar niet: het bestand werd geladen, was syntactisch geldig en de
   modules ervóór werkten, maar vanaf een bepaald punt stopte de uitvoering. De
   precieze oorzaak heb ik niet kunnen vastpinnen - vermoedelijk gooit een
   module ertussenin een fout op juist die templates.

   Los bestand betekent dat AR niet meer kan omvallen door een fout in iets
   waar het niets mee te maken heeft. Dat is hier extra belangrijk omdat de
   klok- en plank-templates een configurator-app draaien die de DOM herbouwt.
   =========================================================================== */

/* ===========================================================================
   AR OP DE PAGINA

   Het maatvenster is geparkeerd; dit is nu het antwoord op de maatvraag. Zie
   snippets/wwc-ar-knop.liquid voor de afwegingen.
   =========================================================================== */
(function () {
  /* NIET één keer vastleggen. Op de klok- en serveerplank-templates herbouwt de
     configurator-app een deel van de DOM ná het laden; een vastgelegde
     verwijzing wijst dan naar een element dat uit de pagina is gehaald. Het
     gevolg was stil: de link stond er, maar klikken deed niets omdat de module
     een verweesd venster bijwerkte. Dus telkens opnieuw opzoeken. */
  function blokNu() { return document.querySelector('[data-ar-blok]'); }

  /* Basis voor de maattekeningen. Zelfde naamgeving als de AR-modellen, zodat
     er maar één conventie is om te onthouden. */
  function maatfotoUrl(soort, mm) {
    var b = window.WWC_AR_BASIS || '';
    return b + 'maat-' + soort + '-' + mm + '.jpg';
  }

  function kan() {
    /* Desktop-Safari meldt óók relList.supports('ar'), maar daar is geen camera.
       Dus ook een aanraakscherm eisen. */
    if (!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches)) return false;
    var a = document.createElement('a');
    return (a.relList && a.relList.supports && a.relList.supports('ar')) ||
           /android/i.test(navigator.userAgent);
  }

  function maatCm() {
    var k = window.WWC && window.WWC.getSelection ? window.WWC.getSelection() : null;
    if (k && k.sizeNumber) return k.sizeNumber;
    /* Geen maat-radio (klok, magneet, onderzetter)? Dan de maat uit het
       attribuut. Hier stond een verwijzing naar het maatvenster; dat is
       geparkeerd, waardoor de klok op 0 uitkwam en de link verdween. */
    var b = document.querySelector('[data-ar-blok]');
    return b ? (parseFloat(b.getAttribute('data-ar-maat-cm')) || 0) : 0;
  }

  function bij() {
    if (!blokNu()) {
      /* Geen venster op deze pagina, maar mogelijk wel een link: de quick-shop
         van een collectiepagina rendert de maatknoppen (en dus de labelregel)
         zonder de feitenrij waarin het venster staat. Een link die niets kan
         openen hoort er niet te staan. */
      var losse = document.querySelectorAll('[data-ar-open]');
      for (var i = 0; i < losse.length; i++) { losse[i].hidden = true; }
      return;
    }
    var cm = maatCm();
    var mm = Math.round(cm * 10);
    var beschikbaar = (blokNu().getAttribute('data-ar-maten') || '').split(',');

    /* De knop mag nooit naar een 404 wijzen. Bestaat er geen model voor deze
       maat - ronde klok, planken - dan verdwijnt het blok in plaats van een
       belofte te doen die stukloopt. */
    var heeftModel = beschikbaar.indexOf(String(mm)) > -1;

    /* Zonder model helemaal verbergen - een knop die naar een 404 wijst is
       erger dan geen knop. MET model maar zonder camera (desktop): wel tonen,
       maar dan de QR-tak. Anders weet iemand achter een computer niet eens dat
       de functie bestaat. */
    /* Geen model? Dan ook geen link: die mag nooit een venster openen dat op
       een 404 uitkomt. */
    var link = document.querySelector('[data-ar-open]');
    if (link) link.hidden = !heeftModel;
    if (!heeftModel) return;

    var opTouch = kan();
    var knop = blokNu().querySelector('.wwc-arv__knop');
    var uitleg = blokNu().querySelectorAll('[data-ar-uitleg], [data-ar-uitleg2], [data-ar-uitleg3]');
    var desktop = blokNu().querySelector('[data-ar-desktop]');
    if (knop) knop.hidden = !opTouch;
    uitleg.forEach(function (p) { p.hidden = !opTouch; });
    if (desktop) desktop.hidden = opTouch;
    if (!opTouch) {
      var ios0 = blokNu().querySelector('[data-ar-ios]');
      if (ios0) ios0.hidden = true;
      return;
    }

    var basis = window.WWC_AR_BASIS || '';
    var soort = blokNu().getAttribute('data-ar-soort');
    var link = blokNu().querySelector('[data-ar-link]');
    if (link) {
      /* URL'S MET VERSIE, ANDERS BLIJFT DE CDN HET OUDE MODEL SERVEREN.

         Hier werd een kale URL samengeplakt uit basis + naam. Die bevat geen
         `?v=`-parameter, en de Shopify-CDN cachet zo'n asset langdurig: een
         vernieuwd model belandt dan wel in het thema maar niet op de telefoon.
         Gemeten op 18 aug - het thema had de rechtopstaande skyline terwijl de
         CDN nog de platliggende versie uitleverde.

         Liquid zet de complete URL's nu in WWC_AR_URLS (zie wwc-cro-config).
         Staat een maat daar niet in, dan valt hij terug op het oude gedrag, dus
         een nieuwe maat werkt meteen - alleen zonder automatische verversing. */
      var sleutel = soort + '-' + mm + 'mm';
      var kaart = (window.WWC_AR_URLS || {})[sleutel];
      link.setAttribute('href', kaart && kaart.usdz ? kaart.usdz : basis + sleutel + '.usdz');
      link.setAttribute('data-ar-glb', kaart && kaart.glb ? kaart.glb : basis + sleutel + '.glb');
    }

    /* De knop NOEMT de maat die hij toont. Geen tweede maatkeuze: die staat al
       bovenaan, en twee keuzes betekent onduidelijkheid over welke telt. */
    var label = blokNu().querySelector('[data-ar-label]');
    if (label) {
      var basiswoord = label.getAttribute('data-basis') || label.textContent.trim();
      label.setAttribute('data-basis', basiswoord);
      /* Een NAAM wint van de maat. Bij een klok is er geen maatkeuze, dus
         "Bekijk 40 cm" suggereert een keuze die niet bestaat - en bij de ronde
         klok stond er "Bekijk 44 cm", een getal dat nergens op de pagina staat.
         Liquid geeft de naam mee in data-ar-naam; is die leeg (skyline,
         standing) dan blijft het de maat, want daar KIES je die wel. */
      var naam = blokNu().getAttribute('data-ar-naam');
      label.textContent = naam ? basiswoord + ' ' + naam : basiswoord + ' ' + cm + ' cm';
    }

    var ios = blokNu().querySelector('[data-ar-ios]');
    if (ios) ios.hidden = !/iPad|iPhone|iPod/.test(navigator.userAgent);
  }

  /* De maattekening laadt op verzoek en verdwijnt als het bestand er niet is.
     Zo hoeft er niets geconfigureerd te worden: upload je maat-skyline-800.jpg,
     dan verschijnt hij vanzelf. */
  function maatfoto() {
    if (!blokNu()) return;
    var doos = blokNu().querySelector('[data-ar-maatfoto]');
    var img = blokNu().querySelector('[data-ar-maatfoto-img]');
    if (!doos || !img) return;
    var mm = Math.round(maatCm() * 10);
    var url = maatfotoUrl(blokNu().getAttribute('data-ar-soort'), mm);
    if (img.getAttribute('src') === url) return;
    img.onload = function () { doos.hidden = false; };
    img.onerror = function () { doos.hidden = true; };
    img.setAttribute('src', url);
  }

  /* CAPTURE-fase: de variantafhandeling van het thema roept stopPropagation
     aan binnen het label, waardoor de bubble-fase document nooit bereikt. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    if (e.target.closest('[data-ar-open]')) {
      bij();
      /* bij() kan de link net verborgen hebben omdat er geen venster is; dan
         valt hier niets te openen. Zonder deze regel crasht de klik op
         blokNu().showModal van null. */
      if (!blokNu()) return;
      maatfoto();
      if (blokNu().showModal) blokNu().showModal();
      if (window.dataLayer) {
        window.dataLayer.push({ event: 'wwc_ar_open', ar_soort: blokNu().getAttribute('data-ar-soort') });
      }
      return;
    }
    if (e.target.closest('[data-ar-sluit]')) {
      if (blokNu().close) blokNu().close();
      return;
    }

    if (!e.target.closest('[data-ar-start]')) return;
    var link = blokNu().querySelector('[data-ar-link]');
    if (!link || !link.getAttribute('href')) return;

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'wwc_ar_start',
        ar_soort: blokNu().getAttribute('data-ar-soort'),
        ar_vlak: blokNu().getAttribute('data-ar-vlak'),
        maat_cm: maatCm()
      });
    }

    if (/android/i.test(navigator.userAgent)) {
      var glb = new URL(link.getAttribute('data-ar-glb'), location.href).href;
      window.location.href =
        'intent://arvr.google.com/scene-viewer/1.0?file=' + encodeURIComponent(glb) +
        '&mode=ar_preferred#Intent;scheme=https;package=com.google.android.googlequicksearchbox;' +
        'action=android.intent.action.VIEW;S.browser_fallback_url=' +
        encodeURIComponent(location.href) + ';end;';
    } else {
      link.click();
    }
  }, true);

  /* QR pas ophalen als erom gevraagd wordt: de externe dienst hoeft de
     product-URL niet te zien bij elke paginaweergave. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-ar-qr-toon]')) return;
    var doos = blokNu().querySelector('[data-ar-qr]');
    var beeld = blokNu().querySelector('[data-ar-qr-beeld]');
    if (!doos || !beeld) return;
    doos.hidden = false;
    e.target.closest('[data-ar-qr-toon]').hidden = true;
    if (!beeld.firstChild) {
      var img = document.createElement('img');
      img.width = 132; img.height = 132; img.alt = '';
      img.loading = 'lazy';
      /* De QR brengt de bezoeker niet naar de kale productpagina maar naar
         DEZE variant met het venster al open. Scheelt op de telefoon twee
         handelingen: zoeken waar de link stond en hem aantikken. */
      var u = new URL(location.href);
      u.hash = '';
      var vId = (document.querySelector('[name="id"]') || {}).value;
      if (vId) u.searchParams.set('variant', vId);
      u.searchParams.set('ar', '1');
      img.src = 'https://api.qrserver.com/v1/create-qr-code/?size=264x264&data=' +
                encodeURIComponent(u.toString());
      beeld.appendChild(img);
    }
    if (window.dataLayer) window.dataLayer.push({ event: 'wwc_ar_qr_toon' });
  }, true);

  document.addEventListener('wwc:selection', bij);

  /* Binnengekomen via de QR-code? Dan het venster meteen openen. De vlag gaat
     daarna uit de URL zodat een vernieuwing of een gedeelde link niet opnieuw
     een venster opengooit. */
  function viaQr() {
    if (new URLSearchParams(location.search).get('ar') !== '1') return;
    var link = document.querySelector('[data-ar-open]');
    if (!link || link.hidden) return;
    window.setTimeout(function () { link.click(); }, 400);
    var u = new URL(location.href);
    u.searchParams.delete('ar');
    history.replaceState(null, '', u.toString());
  }

  /* DIRECTE BINDING NAAST DE GEDELEGEERDE.

     Op de klok- en serveerplank-templates kwam de gedelegeerde klik niet aan:
     het script is de juiste versie, syntactisch geldig, zonder fouten, en de
     klik bereikt document in de capture-fase - maar de handler draaide niet.
     De oorzaak heb ik niet kunnen vastpinnen; vermoedelijk eet de
     configurator-app het event ergens op.

     Daarom hier een tweede route die niet van delegatie afhangt: rechtstreeks
     op de knop. De vlag voorkomt dat een klik dubbel wordt afgehandeld wanneer
     beide routes wel werken. */
  function bindLink() {
    var link = document.querySelector('[data-ar-open]');
    if (!link || link.__wwcArGebonden) return;
    link.__wwcArGebonden = true;
    link.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var v = blokNu();
      if (!v || v.open) return;
      bij();
      maatfoto();
      if (v.showModal) v.showModal();
      if (window.dataLayer) {
        window.dataLayer.push({ event: 'wwc_ar_open', ar_soort: v.getAttribute('data-ar-soort') });
      }
    });

    var sluit = blokNu() && blokNu().querySelector('[data-ar-sluit]');
    if (sluit && !sluit.__wwcArGebonden) {
      sluit.__wwcArGebonden = true;
      sluit.addEventListener('click', function () {
        var v = blokNu();
        if (v && v.close) v.close();
      });
    }
  }

  /* De configurator vervangt op sommige templates een deel van de DOM na het
     laden; dan is de binding weg en moet hij opnieuw. */
  function houdGebonden() {
    bindLink();
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function () { bindLink(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bij(); viaQr(); houdGebonden(); });
  } else { bij(); viaQr(); houdGebonden(); }
})();
